import { HttpClient } from '@/shared/lib/http-client';

export const searchCityById = async (cityId) => {
  const response = await HttpClient.get('/directories/cities/get-by-id', {
    id: cityId,
  });

  return response.data?.data;
};
